import { Translate } from "client/utils/internationalization";

import { FAQ } from "./types";

export const getAddCustomerSupportFaqs = (t: Translate): FAQ[] => [
  {
    question: t("uiFaqAddCustomerSupportRefundCustomerQuestion"),
    answer: t("uiFaqAddCustomerSupportRefundCustomerAnswer"),
  },
];
